function newsletterEditorialeLabel(role) {
  if (role === "ROLE_TEACHER" || role === "ROLE_GENERIC" || role === "ROLE_PRINCIPAL") {
    return {
      label: `<span class="dea-heading--regular-xs">Novità e informazioni sui libri, 
        i prodotti digitali e i servizi di Deascuola dedicati ai docenti. 
        Novità dal blog Dlive, dedicato al mondo educational.</span>`,
      compact: `Novità e informazioni sui libri, 
        i prodotti digitali e i servizi di Deascuola dedicati ai docenti. 
        Novità dal blog Dlive, dedicato al mondo educational.`,
    };
  }
  if (role === "ROLE_STUDENT") {
    return {
      label: `<span class="dea-heading--regular-xs">Novità e informazioni sui libri, 
        i prodotti digitali e i servizi di Deascuola dedicati agli studenti.</span>`,
      compact: `Novità e informazioni sui libri, i prodotti digitali 
        e i servizi di Deascuola dedicati agli studenti.`,
    };
  }
  if (role === "ROLE_PARENT") {
    return {
      label: `<span class="dea-heading--regular-xs">Novità e informazioni sui libri, 
        i prodotti digitali e i servizi di Deascuola dedicati agli studenti. 
        Novità dal blog Dlive, dedicato al mondo educational.</span>`,
      compact: `Novità e informazioni sui libri, i prodotti digitali e i servizi di 
        Deascuola dedicati agli studenti. Novità dal blog Dlive, dedicato al mondo educational.`,
    };
  }
  return "";
}

function newsletterFormazioneLabel(role) {
  if (role === "ROLE_TEACHER" || role === "ROLE_GENERIC" || role === "ROLE_PRINCIPAL") {
    return {
      label: `<span class="dea-heading--regular-xs">Proposte formative e inviti a eventi organizzati da Deascuola Formazione.</span>`,
      compact: `Proposte formative e inviti a eventi organizzati da Deascuola Formazione.`,
    };
  }
  return "";
}

export default function(role) {
  return {
    newsletter: {
      title: "Su quali tematiche vorresti ricevere informazioni?",
      options: [
        {
          id: "newsletters_editoriale",
          label: newsletterEditorialeLabel(role).label,
          // FIXME: Waiting for final compact labels
          compact: newsletterEditorialeLabel(role).compact,
        },
        {
          id: "newsletters_formazione",
          label: newsletterFormazioneLabel(role).label,
          // FIXME: Waiting for final compact labels
          compact: newsletterFormazioneLabel(role).compact,
        },
      ],
    },
    messages: {
      title: "Quali sono le aree da cui vorresti ricevere notifiche?",
      description: "Riceverai le notifiche quando entrerai in Area Personale, con brevi messaggi e avvisi visuali.",
      // FIXME: We lack ids for this section
      options: [
        {
          id: "newsletters_editoriale",
          label:
            role === "ROLE_GENERIC"
              ? ""
              : `<span class="dea-heading--regular-xs">Libri</span>
            <br><span class="dea-heading--regular-xxs">CONSIGLIATO - 
            Ti informeremo quando sono disponibili i nuovi libri digitali
            e ti ricorderemo la scadenza delle licenze ad essi associate.</span>`,
          compact: role === "ROLE_GENERIC" ? "" : "Libri",
        },
        {
          id: "newsletters_editoriale",
          label:
            role === "ROLE_STUDENT" || role === "ROLE_PARENT"
              ? ""
              : `<span class="dea-heading--regular-xs">Formazione</span>
            <br><span class="dea-heading--regular-xxs">CONSIGLIATO - Riceverai i promemoria riguardanti i corsi acquistati o 
            per i quali hai effettuato l'iscrizione, la disponibilità
            di attestati e le ricevute dei tuoi acquisti.</span>`,
          compact: role === "ROLE_STUDENT" || role === "ROLE_PARENT" ? "" : "Formazione",
        },
        {
          id: "newsletters_editoriale",
          label: `<span class="dea-heading--regular-xs">Preferiti</span>
            <br><span class="dea-heading--regular-xxs">CONSIGLIATO - 
            Ti informeremo quando aggiungi qualcosa ai preferiti.</span>`,
          compact: "Preferiti",
        },
      ],
    },
    privacy: {
      title: "Modifica le opzioni di trattamento dei tuoi dati personali (Privacy)",
      description: `Dichiaro di aver preso visione dell’%(privacy-link)s fornita ai sensi dell'art. 13 del Regolamento (UE) 2016/679`,
      options: [
        {
          id: "cons_promo",
          label: `<span class="dea-heading--regular-xs">Per la finalità di marketing di cui alla Sezione E, punto (i) dell’Informativa, 
          in virtù dell’articolo 6, comma 1, punto f) del Regolamento, 
          il Titolare del Trattamento potrà svolgere tale attività basandosi sul suo interesse legittimo, 
          a prescindere dal tuo consenso e comunque sino ad una tua opposizione a tale Trattamento come meglio esplicitato 
          nel Considerando 47 del Regolamento nel quale viene “considerato legittimo interesse trattare dati personali per finalità di marketing diretto”. 
          A tal proposito, i tuoi Dati Personali saranno trattati per informarti su servizi e iniziative promozionali del Titolare del Trattamento, 
          anche mediante modalità di contatto di tipo automatizzato o tradizionale. 
          Qualora non volessi ricevere comunicazioni per tale finalità ti invitiamo a spuntare la seguente casella ☐ 
          opponendoti sin d’ora al trattamento oppure potrai limitare le attività di Trattamento a specifiche modalità di contatto comunicandolo 
          al Titolare del Trattamento tramite i canali di contatto di cui all’Informativa.</span>`,
          compact: "Marketing Diretto",
        },
        {
          id: "cons_promo3",
          label: `<span class="dea-heading--regular-xs">Per la finalità di marketing indiretto, di cui alla Sezione E, punto (ii) dell’Informativa, 
          i tuoi Dati Personali saranno trattati dal Titolare del Trattamento per informarti su servizi e iniziative promozionali di soggetti terzi, 
          anche mediante modalità di contatto di tipo automatizzato (e-mail) o tradizionale (telefono con operatore, posta), 
          con avvertenza che in qualsiasi momento potrai revocare il consenso anche in via parziale, 
          per esempio nei riguardi delle sole modalità di contatto automatizzate.
          </span>`,
          compact: "Marketing Indiretto",
        },
        {
          id: "cons_consumi",
          label: `<span class="dea-heading--regular-xs">Per la finalità di profilazione di cui alla Sezione E, 
          punto (iii) dell’Informativa i tuoi Dati Personali saranno trattati dal Titolare del Trattamento per profilarti ossia valutare i tuoi gusti, 
          preferenze ed abitudini di consumo anche correlate ad indagini di mercato ed analisi di tipo statistico. 
          Rientra in questa categoria qualsiasi forma di Trattamento automatizzato di Dati Personali per valutare determinati aspetti personali quali quelli riguardanti, 
          a titolo esemplificativo e non esaustivo, il rendimento professionale, la situazione economica, le preferenze personali, 
          gli interessi, l’affidabilità, il comportamento, l’ubicazione o gli spostamenti. 
          </span>`,
          compact: "Profilazione",
        },
      ],
    },
  };
}
